import { checkLength } from './index'
import _, { some } from 'lodash'
/**
 * rule 隐射
 * 解析 - 自定义
 */
const ruleMap = {
    valueAttributeRule: (ruleValue) => {
        return {}
        // return {
        //     isInputValue: ruleValue === 'inputValue'
        // }
    },
    // valueTypeRule，用于描述field值需要满足数据类型，包括了text（文本型）/decimal（小数型）/integer（整数型）/date（日期型）/long（长整数型）/url（超链接）/textarea（多行文本）/html（支持html标记语法的文本）
    valueTypeRule: () => {
        // 暂时不处理
        return {}
    },
    // requiredRule，是否必填，默认为false，true/false
    requiredRule: (ruleValue, fieldItem) => {
        // if (fieldItem.parentName && fieldItem.parentName === 'catProp') {
        //     if (ruleValue !== 'true') return {}
        //     // 若是类目属性 必填校验需要特殊处理
        //     return {
        //         required: true,
        //         validator(rule, value, cb) {
        //             if (fieldItem.type === 'INPUT') {
        //                 if (!value || (value && !value[0]?.displayName)) {
        //                     return cb(new Error('必填'))
        //                 }
        //             } else {
        //                 if (!value || (value && !value[0]?.value)) {
        //                     return cb(new Error('必填'))
        //                 }
        //             }
                    
        //             cb()
        //         }
        //     }
        // }

        return {
            required: ruleValue === 'true',
            message: '必填'
        }
    },
    // disableRule，是否忽略此field，为true时，将不对rule进行check，同时他的value也将无效。默认为false，值范围包含true/false
    disableRule: () => {
        return {}
    },
    // maxLengthRule ，最大长度
    maxLengthRule: (ruleValue, fieldItem, rule) => {
        const isShoppingTitle = fieldItem.name === "shopping_title" // 是否是导购标题
        // 暂时只处理input类型
        if (fieldItem.type === 'INPUT' || isShoppingTitle) {
                return {
                    validator(rule, value) {
                        if (checkLength(value) > ruleValue) {
                            return Promise.reject(
                                new Error('长度不能大于' + ruleValue + '字节(汉字占2字节，英文占1字节)')
                            )
                        }
                        return Promise.resolve()
                    }
                }
        }
        return {}
    },
    // minLengthRule ，最小长度
    minLengthRule: (ruleValue, fieldItem) => {
        const isShoppingTitle = fieldItem.name === "shopping_title" // 是否是导购标题
        // 暂时只处理input类型，其实多选单休如果出现input也需要验证
        if (fieldItem.type === 'INPUT' || isShoppingTitle) {
            if (fieldItem.rules.unit === 'byte' || isShoppingTitle) {
                return {
                    validator(rule, value) {
                        if (value && checkLength(value) < ruleValue) {
                            return Promise.reject(
                                new Error('长度不能小于' + ruleValue + '字节(汉字占2字节，英文占1字节)')
                            )
                        }
                        return Promise.resolve()
                    }
                }
            }

            return {
                type: 'string',
                min: parseInt(ruleValue, 10),
                message: '文字长度不能小于' + ruleValue + '字符'
            }
        }

    },
    // maxValueRule，最大值（数值类型或数组时有效）
    maxValueRule: (ruleValue, fieldItem) => {
        if (ruleValue === 'date') {
            return {}
        } else {
            if (isNaN(Number(ruleValue))) {
                return {}
            }
            if (fieldItem.exProperty === 'include') {
                // 包含
                if (fieldItem.type === 'MULTICHECK') {
                    return {
                        type: 'array',
                        max: parseInt(ruleValue, 10),
                        message: '最多可选' + ruleValue
                    }
                } else {
                    return {
                        type: 'number',
                        max: parseFloat(ruleValue, 10),
                        message: '值不能大于' + ruleValue
                    }
                }
            } else {
                // 不包含
                return {
                    validator(rule, value, callback) {
                        if (!value) {
                            return Promise.resolve();
                        }
                        const isArray = value instanceof Array
                        if (value && !isArray && isNaN(Number(value))) {
                            return Promise.reject(new Error('请输入数字'))
                        }
                        if (parseFloat(isArray ? value.length : value, 10) <= parseFloat(ruleValue, 10)) {
                            return Promise.resolve()
                        } else {
                            return Promise.reject(
                                isArray ? new Error('最多只能选择' + ruleValue + '个值')
                                : new Error('值不能大于' + ruleValue )
                            )
                        }
                    }
                }
            }
        }
    },
    // minValueRule ，最小值（数值类型或数组时有效）
    minValueRule: (ruleValue, fieldItem) => {
        if (fieldItem.valueTypeRule === 'date') {
            return {}
        } else {
            if (isNaN(Number(ruleValue))) {
                return {}
            }

            if (fieldItem.exProperty === 'include') {
                // 包含
                if (fieldItem.type === 'MULTICHECK') {
                    return {
                        type: 'array',
                        min: parseInt(ruleValue, 10),
                        message: '至少要选' + ruleValue
                    }
                } else {
                    return {
                        type: 'number',
                        min: parseFloat(ruleValue, 10),
                        message: '值不能小于' + ruleValue
                    }
                }
            } else {
                // 不包含
                return {
                    validator(rule, value, callback) {
                        if (!value) {
                            return Promise.resolve();
                        }
                        const isArray = value instanceof Array
                        if (!isArray && isNaN(Number(value))) {
                            return Promise.reject(new Error('请输入数字'))
                        }
                        if (parseFloat(isArray ? value.length : value, 10) >= parseFloat(ruleValue, 10)) {
                            return Promise.resolve()
                        } else {
                            return Promise.reject(
                                isArray ? new Error('最少选择' + ruleValue + '个值')
                                : new Error('值不能小于' + ruleValue)
                            )
                        }
                    }
                }
            }
        }
    },
    // maxInputNumRule ，最多可选数（多选时有效）
    maxInputNumRule: (ruleValue) => {
        return {
            type: 'array',
            max: parseInt(ruleValue, 10),
            message: '最多可选' + ruleValue
        }
    },
    // minInputNumRule ，至少要选数（多选时有效）
    minInputNumRule: (ruleValue) => {
        return {
            type: 'array',
            min: parseInt(ruleValue, 10),
            message: '至少要选' + ruleValue
        }
    },
    // maxTargetSizeRule ，最大目标文件大小
    maxTargetSizeRule: (ruleValue) => {
        const fileSize = Math.round((ruleValue / 1024 / 1024) * 100) / 100
        return {}
        // return {
        //     prop: {
        //         maxSize: fileSize
        //     },
        //     tipRule: '最大文件大小: ' + fileSize + '(m)'
        // }
    },
    // minTargetSizeRule ，最小目标文件大小
    minTargetSizeRule: (ruleValue) => {
        const fileSize = Math.round((ruleValue / 1024 / 1024) * 100) / 100
        return {
            prop: {
                maxSize: fileSize
            },
            tipRule: '最小文件大小: ' + fileSize + '(m)'
        }
    },
    // readOnlyRule ，只读，用户无法修改返回值，值范围为true/false
    readOnlyRule: (ruleValue) => {
        return {}
    },
    // regxRule ， 正则表达式匹配
    regexRule: (ruleValue) => {
        if (ruleValue === 'date') {
            return {}
        } else {
            let _ruleValue = ruleValue.replaceAll('\\.', '\\.')
            return {
                pattern: new RegExp(`^${_ruleValue}$`),
                message: `请填写正确值: ${_ruleValue}`
            }
        }
    },
    // tipRule ，Field中展示的tip信息，用于一些无法直接用语法描述或者过于复杂的规则，或者提示信息,需要给用户透出。
    tipRule: (ruleValue) => {
        const tipRule = ruleValue.split(';')
        if (tipRule.length >= 0) {
            return tipRule
        } else {
            return []
        }
    },
    // maxImageSizeRule，最大图片大小，指的是分辨率，如800*800
    maxImageSizeRule: (ruleValue) => {
        const Size = ruleValue.split('x')

        return {
            prop: {
                maxWidth: parseInt(Size[0], 10),
                maxHeight: parseInt(Size[1], 10)
            },
            tipRule: '最大图片大小: ' + ruleValue
        }
    },
    // minImageSizeRule ， 最小图片大小
    minImageSizeRule: (ruleValue) => {
        const Size = ruleValue.split('x')

        return {
            // prop: {
            //     minWidth: parseInt(Size[0], 10),
            //     minHeight: parseInt(Size[1], 10)
            // },
            // tipRule: '最小图片大小: ' + ruleValue
        }
    },
    // +devTipRule，一般用于给开发者提示，不需要展示给用户，开发者可以通过此Rule获取特定的信息，如例子中的如何获取售后模板信息。
    devTipRule: () => { return {} },
    asyncRenderRule: () => { return {} },
    maxItemsRule: () => { return {} },
    unitTypeRule: () => { return {} },
    unit: () => { return {} }, // 用不到 防止报错
}

/**
 * 匹配生成rule规则
 * 遍历 - 匹配
 * @param {*} rule 
 */
const buildRules = (rulesKeys, rules = {}, field) => {
    return rulesKeys.reduce((item, key) => {

        const rule = ruleMap[key] ? ruleMap[key](rules[key], field, rules) : {};

        if (_.isEmpty(rule)) return item // 处理返回空对象的类型 {}

        if (key === 'tipRule') {
            field['tipRule'] = rule
            return item
        } else {
            return item.concat([rule])
        }
    }, [])
}

/**
 * 获取 rules
 * 判空 - 转数组
 * @param {*} rules 
 * @returns 
 */
export const getRules = (field) => {
    const rules = field.rules || {}
    if (Array.isArray(rules)) return field.rules // 如果已经是了直接返回
    if (['tbDeliveryTime'].includes(field.name)) {
        // PC端详情、发货时间天数需要必填
        rules.requiredRule = "true"
    }

    const rulesKeys = Object.keys(rules)
    if (rulesKeys.length <= 0) return []
    field._oriRules = rules;
    return buildRules(rulesKeys, rules, field)
}

/**
 * 获取多实例复合型表单的校验
 * @param {*} field 
 */
export const getMultiComplexRules = (field) => {
    let { rules = {}, label } = field
    if (Array.isArray(rules)) return field.rules // 如果已经是了直接返回

    let _rules = []
    rules = rules || {}
    if (rules.requiredRule && rules.requiredRule === 'true') {
        _rules.push({
            required: true,
            validator: (rule, value, cb) => {
                if (!value || !value.length) {
                    cb(new Error(`${label}必填一份数据`)) 
                } else {
                    
                    let hasVoid = value.some((item) => {
                        return Object.values(item).some(v => (v === undefined || v === '')) 
                    });
                    hasVoid ? cb(new Error(`${label}子项请勿留空`)) : cb()
                }
            },
        })
    }
    if (rules.maxInputNumRule) {
        _rules.push({
            validator: (rule, value, cb) => {
                if (value && value.length > Number(rules.maxInputNumRule)) {
                    cb(new Error(`不能超过${rules.maxInputNumRule}份数据`))
                } else {
                    cb()
                }
            },
        })
    }
    return _rules;
}
